
export const IDisplayMode = {
    Full : 1,
    Table : 2,
    Text: 3,
    Other : 99
}